// extracted by mini-css-extract-plugin
export default {"input_area":"InputTable_input_area__wsa-6","table":"InputTable_table__bOjDm"};